import { Accepts, Types } from "@citychallenge/common";
import { Inlet, Outlet } from "../../reactive";
import { defineElement } from "../define-element";

export class BranchingChoiceProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public introduction?: Types["MarkdownText"];
  @Inlet(Accepts.Text) public question?: Types["Text"];
  @Inlet(Accepts.IdAndLabelList) public options?: Types["IdAndLabelList"];

  @Inlet(Accepts.ChoiceOptionLayout)
  public optionLayout?: Types["ChoiceOptionLayout"];

  @Inlet(Accepts.Boolean) public allowReselecting?: Types["Boolean"];

  @Outlet({
    arguments: {
      option: {
        type: Accepts.IdAndLabel,
        inlet: "options",
      },
    },
    repeatable: true,
  })
  public chosenOption!: (value: { option: Types["IdAndLabel"] }) => void;
}

export const BranchingChoiceDefinition = defineElement(
  "branching-choice",
  BranchingChoiceProps,
  {
    versionRequired: "0.24.0",
  }
);

export interface BranchingChoiceState {
  activeOption: Types["IdAndLabel"];
  chosenOptions?: string[];
  branchEventFired?: boolean;
}
